import React from 'react';

interface HotelTitleProps {
    name: string;
    title: string;
    subtitle: string;
    type: 'main' | 'secondary';
}

const HotelTitle = ({ name, title, subtitle, type }: HotelTitleProps) => {
    return (
        <div className={`hotel-title__container --${type}`}>
            <h3 className={`hotel-title__title --${type}`}>{title}</h3>
            <h2 className='hotel-title__name'>{name}</h2>
            <h4 className='hotel-title__subtitle'>{subtitle}</h4>
        </div>
    );
};

export default HotelTitle;
